/* ============================================================
   SPOOKY SEASON SKIN 2026 — ambient canvas
   Falling autumn leaves + flapping bats, fixed to viewport.
   - pointer-events: none (never blocks clicks)
   - low opacity via CSS (#hw-ambient-canvas)
   - disabled when prefers-reduced-motion is set
   - zero dependencies
   ============================================================ */
(function () {
  'use strict';

  // Respect users who prefer reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Don't double-init (e.g. theme editor re-renders)
  if (document.getElementById('hw-ambient-canvas')) return;

  var canvas = document.createElement('canvas');
  canvas.id = 'hw-ambient-canvas';
  canvas.setAttribute('aria-hidden', 'true');
  document.body.appendChild(canvas);

  var ctx = canvas.getContext('2d');
  var W, H, particles = [];

  var LEAF_COLORS = ['#ff6b35', '#ffa25e', '#c2410c', '#a855f7', '#6b21a8'];

  function resize() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();
  window.addEventListener('resize', resize);

  function makeLeaf() {
    return {
      type: 'leaf',
      x: Math.random() * W,
      y: -20 - Math.random() * 40,
      size: 6 + Math.random() * 10,
      vy: 0.5 + Math.random() * 1.2,
      vx: -0.6 + Math.random() * 1.2,
      angle: Math.random() * Math.PI * 2,
      spin: -0.03 + Math.random() * 0.06,
      swayAmp: 20 + Math.random() * 40,
      swaySpeed: 0.005 + Math.random() * 0.015,
      t: Math.random() * 1000,
      color: LEAF_COLORS[(Math.random() * LEAF_COLORS.length) | 0]
    };
  }

  function makeBat() {
    return {
      type: 'bat',
      x: Math.random() < 0.5 ? -40 : W + 40,
      y: Math.random() * H * 0.45,
      size: 10 + Math.random() * 8,
      vx: (Math.random() < 0.5 ? 1 : -1) * (1.2 + Math.random() * 1.6),
      vy: -0.3 + Math.random() * 0.6,
      t: Math.random() * 1000,
      flapSpeed: 0.25 + Math.random() * 0.2,
      bobAmp: 12 + Math.random() * 18,
      bobSpeed: 0.01 + Math.random() * 0.02
    };
  }

  function seed() {
    particles = [];
    var leafCount = Math.min(46, Math.floor(W / 28));
    for (var i = 0; i < leafCount; i++) {
      var leaf = makeLeaf();
      leaf.y = Math.random() * H; // pre-scatter so the screen isn't empty on load
      particles.push(leaf);
    }
    for (var j = 0; j < 6; j++) {
      var bat = makeBat();
      bat.x = Math.random() * W;
      particles.push(bat);
    }
  }
  seed();

  function drawLeaf(p) {
    ctx.save();
    ctx.translate(p.x, p.y);
    ctx.rotate(p.angle);
    ctx.fillStyle = p.color;
    ctx.globalAlpha = 0.75;
    // simple leaf: ellipse + stem
    ctx.beginPath();
    ctx.ellipse(0, 0, p.size, p.size * 0.55, 0, 0, Math.PI * 2);
    ctx.fill();
    ctx.strokeStyle = 'rgba(0,0,0,0.25)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(-p.size, 0);
    ctx.lineTo(-p.size - 4, -3);
    ctx.stroke();
    ctx.restore();
  }

  function drawBat(p) {
    var flap = Math.sin(p.t * p.flapSpeed) * 0.9;
    var s = p.size;
    ctx.save();
    ctx.translate(p.x, p.y);
    if (p.vx < 0) ctx.scale(-1, 1);
    ctx.fillStyle = '#1c1030';
    ctx.globalAlpha = 0.8;
    // body
    ctx.beginPath();
    ctx.ellipse(0, 0, s * 0.28, s * 0.42, 0, 0, Math.PI * 2);
    ctx.fill();
    // wings — flap by rotating the wing ellipses
    [-1, 1].forEach(function (side) {
      ctx.save();
      ctx.translate(side * s * 0.2, 0);
      ctx.rotate(side * (0.5 + flap * 0.7));
      ctx.beginPath();
      ctx.ellipse(side * s * 0.55, -s * 0.15, s * 0.62, s * 0.26, side * 0.35, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    });
    // ears
    ctx.beginPath();
    ctx.moveTo(-s * 0.14, -s * 0.36);
    ctx.lineTo(-s * 0.2, -s * 0.58);
    ctx.lineTo(-s * 0.05, -s * 0.42);
    ctx.moveTo(s * 0.14, -s * 0.36);
    ctx.lineTo(s * 0.2, -s * 0.58);
    ctx.lineTo(s * 0.05, -s * 0.42);
    ctx.fill();
    ctx.restore();
  }

  function tick() {
    ctx.clearRect(0, 0, W, H);
    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      p.t++;

      if (p.type === 'leaf') {
        p.y += p.vy;
        p.x += p.vx + Math.sin(p.t * p.swaySpeed) * 0.8;
        p.angle += p.spin;
        drawLeaf(p);
        if (p.y > H + 30 || p.x < -40 || p.x > W + 40) {
          particles[i] = makeLeaf();
        }
      } else {
        p.x += p.vx;
        p.y += p.vy + Math.sin(p.t * p.bobSpeed) * 0.9;
        drawBat(p);
        if ((p.vx > 0 && p.x > W + 60) || (p.vx < 0 && p.x < -60)) {
          particles[i] = makeBat();
        }
      }
    }
    requestAnimationFrame(tick);
  }

  // Pause when the tab is hidden to save battery
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) requestAnimationFrame(tick);
  });

  requestAnimationFrame(tick);
})();
